"use client";

import React, { useMemo } from "react";
import { IMG_URL } from "@/app/config";

export default function HomeImageSection({
  initialImageSections = [],
}) {
  const imageMap = useMemo(
    () => new Map(initialImageSections.map((item) => [item.type, item])),
    [initialImageSections]
  );

  const getItem = (type) => imageMap.get(type);

  const handleClick = (url) => {
    if (url && url.startsWith("http")) {
      window.location.href = url;
    }
  };

  return (
    <section className="cmpad mt-40">
      <div className="row">
        <div className="col-lg-3 col-md-3 col-12 d-none d-sm-block">
          {["l1", "l2", "l3"].map((type, index) => {
            const item = getItem(type);
            if (!item) return null;

            return (
              <div
                key={item.id}
                className="why-box-img"
                onClick={() => handleClick(item.url)}
                style={{ cursor: item.url ? "pointer" : "default" }}
              >
                <img
                  src={`${IMG_URL}${item.photo}`}
                  alt={item.name}
                  className={`wht-img-${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
                <p className={`con-${index + 1}`}>{item.name}</p>
              </div>
            );
          })}
        </div>

        <div className="col-lg-6 col-md-6 col-12">
          <div className="row d-none d-sm-flex">
            {["t1", "t2"].map((type, index) => {
              const item = getItem(type);
              if (!item) return null;

              return (
                <div
                  key={item.id}
                  className={`col-lg-${index === 0 ? 7 : 5} col-md-${index === 0 ? 7 : 5} col-12`}
                >
                  <div
                    className="why-box-img"
                    onClick={() => handleClick(item.url)}
                    style={{ cursor: item.url ? "pointer" : "default" }}
                  >
                    <img
                      src={`${IMG_URL}${item.photo}`}
                      alt="why-vigilance"
                      className="wht-img-3"
                      loading="lazy"
                      decoding="async"
                    />

                    {type === "t2" && (
                      <p className="con-3">
                        <span className="con-s-1">60</span>
                        <span> years of experience</span>
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {(() => {
            const item = getItem("m");
            if (!item) return null;

            return (
              <div
                className="why-box-img"
                onClick={() => handleClick(item.url)}
                style={{ cursor: item.url ? "pointer" : "default" }}
              >
                <img
                  src={`${IMG_URL}${item.photo}`}
                  alt={item.name}
                  className="wht-img-4"
                  loading="lazy"
                  decoding="async"
                />
                <p className="con-4">
                  <span className="con-s-1">Why</span>
                  <span> Vigilance</span>
                </p>
              </div>
            );
          })()}
        </div>

        <div className="col-lg-3 col-md-3 col-12 d-none d-sm-block">
          {["r1", "r2"].map((type, index) => {
            const item = getItem(type);
            if (!item) return null;

            return (
              <div
                key={item.id}
                className="why-box-img"
                onClick={() => handleClick(item.url)}
                style={{ cursor: item.url ? "pointer" : "default" }}
              >
                <img
                  src={`${IMG_URL}${item.photo}`}
                  alt={item.name}
                  className={`wht-img-${5 + index}`}
                  loading="lazy"
                  decoding="async"
                />
                <p className={`con-${5 + index}`}>{item.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
